import { call, put, takeEvery } from "redux-saga/effects";
import { useDispatch, useSelector } from "react-redux";
import * as types from "../config/types";
import * as ipconfig from "../config/ipconfig";


const apiUrl = `https://${ipconfig.apiIP}/api/v1/leonTag/list`;

function getApi(parse) {
  return fetch(apiUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },    
    body: JSON.stringify(parse)
  })
    .then((res) => res.json())
    .catch((error) => {
      throw error;
    });
};

function* fetchLeonTagList(action) {
  try {
    // console.log('leonTag');
    const leonTags = yield call(getApi, action.payload.parse);    
    yield put({type: "CHANGE_TOKEN_STATUS", payload: leonTags.resultCode});
    if(leonTags.resultCode === 'Failed')
      yield put(getLeonTagsError());
    else
      yield put(getLeonTagsSuccess(leonTags));
  } catch (error) {
    yield put(getLeonTagsError(error.message));
  }
}

export const getLeonTagsSuccess = (leonTags) => {
  // console.log("request leonTags success");
  return {
    type: types.GET_LEONTAG_LIST_SUCCESS,
    payload: {
      loading: false,
      leonTags: leonTags
    }
  };
};

export const getLeonTagsError = () => {
  // console.log("request leonTags error");
  return {
    type: types.GET_LEONTAG_LIST_FAILED,
    error: "FAILED"
  };
};

function* leonTagSaga() {
  yield takeEvery(types.GET_LEONTAG_LIST_REQUEST, fetchLeonTagList);
}

export default leonTagSaga;
